import { createAction } from '@reduxjs/toolkit';

export const openNotificationsSnackbar = createAction(
  'notifications/openNotificationsSnackbar'
);

export const closeNotificationsSnackbar = createAction(
  'notifications/closeNotificationsSnackbar'
);
